import { Flexbox, Form } from '@/components'
import AllAnimals from '@/components/AnimalPicker/AllAnimals'
import MyAnimals from '@/components/AnimalPicker/MyAnimals'
import NewAnimal from '@/components/AnimalPicker/NewAnimal'
import yup from '@/lib/yupPt'
import chips from '@/services/api/chips'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'

const chipSchema = yup.object().shape({
  uid: yup.string().trim().required(),
})

function FindByChip({ onSelect, disabled }) {
  const [loading, setLoading] = useState(false)
  const [chip, setChip] = useState(null)

  async function onSubmit(form) {
    try {
      setLoading(true)
      setChip(null)
      const { data } = await chips.findByUid(form.uid)
      if (!data?.animal) {
        toast.error('Este chip não está vinculado a um pet')
        return
      }
      setChip(data)
    } catch (e) {
      toast.error(e?.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="mt-2">
      <fieldset disabled={disabled || loading}>
        <Form.Formik
          initialValues={{ uid: '' }}
          validationSchema={chipSchema}
          onSubmit={onSubmit}
          validateOnMount
        >
          {
            ({ errors, touched, isValid }) => (
              <Form.ValidationForm>
                <Flexbox.Columns className="align-end">
                  <Flexbox.Column>
                    <Form.Group className={`${touched?.uid && errors?.uid ? 'has-error' : ''}`}>
                      <Form.Label htmlFor="uid">Código do microchip <span className="text-error">*</span></Form.Label>
                      <Form.ValidationField
                        name="uid"
                        id="uid"
                        placeholder="Código do chip"
                      />
                      {
                        touched?.uid && errors?.uid
                          ? <Form.Hint className="text-error">{errors.uid}</Form.Hint> : null
                      }
                    </Form.Group>
                  </Flexbox.Column>
                  <Flexbox.Column className="col-auto">
                    <button
                      type="submit"
                      disabled={!isValid || loading}
                      className={`btn btn-primary ${loading ? 'loading' : ''}`}
                    >
                      <i className="fas fa-search" />
                      &nbsp;Buscar
                    </button>
                  </Flexbox.Column>
                </Flexbox.Columns>
              </Form.ValidationForm>
            )
          }
        </Form.Formik>
      </fieldset>
      {
        chip?.animal && (
          <div className="mt-2">
            <p>
              Pet encontrado: <b>{chip.animal.name}</b>
            </p>
            <button
              type="button"
              className="btn btn-primary btn-sm"
              disabled={disabled}
              onClick={() => onSelect(chip.animal)}
            >
              <i className="fas fa-plus" />
              &nbsp;Incluir na baia
            </button>
          </div>
        )
      }
    </div>
  )
}

FindByChip.propTypes = {
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

FindByChip.defaultProps = {
  disabled: false,
}

function AddAnimal({ onAdded, onClose }) {
  const [selected, setSelected] = useState('myAnimals')
  const history = useHistory()
  const location = useLocation()

  function close() {
    history.replace(location.pathname)
    onClose()
  }

  function add(animal) {
    history.replace(location.pathname)
    onAdded(animal)
    onClose()
  }

  return (
    <div className="modal active">
      <a type="button" className="modal-overlay" aria-label="Close" onClick={close} />
      <div className="modal-container">
        <div className="modal-header">
          <a
            type="button"
            className="btn btn-clear float-right"
            onClick={close}
          />
          <div className="modal-title h5">Adicionar pet na baia</div>
        </div>
        <div className="modal-body">
          <div>
            <ul className="tab tab-block">
              <li className="tab-item c-hand">
                <a onClick={() => setSelected('myAnimals')} className={selected === 'myAnimals' ? 'active' : ''}>
                  <i className="fas fa-paw" />
                  &nbsp;Meus pets
                </a>
              </li>
              <li className="tab-item c-hand">
                <a onClick={() => setSelected('allAnimals')} className={selected === 'allAnimals' ? 'active' : ''}>
                  <i className="fas fa-list" />
                  &nbsp;Todos os pets
                </a>
              </li>
              <li className="tab-item c-hand">
                <a onClick={() => setSelected('chip')} className={selected === 'chip' ? 'active' : ''}>
                  <i className="fas fa-microchip" />
                  &nbsp;Microchip
                </a>
              </li>
              <li className="tab-item c-hand">
                <a onClick={() => setSelected('newAnimal')} className={selected === 'newAnimal' ? 'active' : ''}>
                  <i className="fas fa-plus" />
                  &nbsp;Novo pet
                </a>
              </li>
            </ul>
            {
              selected === 'myAnimals' && (
                <MyAnimals onChange={add} />
              )
            }
            {
              selected === 'allAnimals' && (
                <AllAnimals onChange={add} />
              )
            }
            {
              selected === 'chip' && (
                <FindByChip onSelect={add} />
              )
            }
            {
              selected === 'newAnimal' && (
                <NewAnimal onChange={add} />
              )
            }
          </div>
        </div>
      </div>
    </div>
  )
}

AddAnimal.propTypes = {
  onAdded: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default AddAnimal
